export const LocalStorageConstant = {
  DASHBOARD_CSV_DATA: "dashboard_csv_data",
  DASHBOARD_DATERANGE_FILTER: "dashboard_daterange_filter",
  DASHBOARD_SEVERITY_FILTER: "dashboard_severity_filter",
};
